import { styled } from "@styles";

export const Container = styled("div", {
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",

  boxSizing: "border-box",
  border: "1px solid $neutral20",
  borderRadius: "$md",

  width: "100%",
  minHeight: "$100px",
  padding: "$16px",
  gap: "$8px",

  ".title.description": {
    color: "$neutral90",
  },

  variants: {
    variant: {
      success: {
        ".title": {
          color: "$green40",
        },
      },
      info: {
        ".title": {
          color: "$blue40",
        },
      },
      warning: {
        ".title": {
          color: "$yellow40",
        },
      },
      default: {
        ".title": {
          color: "$neutral70",
        },
      },
      disabled: {
        ".title, .title.description": {
          color: "$neutral70",
        },
      },
    },
    centered: {
      true: {
        justifyContent: "center",
      },
    },
  },
});

export const Text = styled("div", {
  display: "flex",
  flexDirection: "row",
  justifyContent: "space-between",
  alignItems: "center",

  width: "100%",
  padding: 0,
  gap: "$8px",
});

export const Title = styled("div", {
  display: "flex",
  flexDirection: "row",
  justifyContent: "flex-start",
  alignItems: "center",

  width: "100%",
  padding: 0,
  gap: "$8px",
});
